import { useKeenSlider } from 'keen-slider/react';
import { useEffect } from 'preact/hooks';
import { useImage } from 'utilities/content';

import { Image } from 'components/Image';

import styles from './MediaList.module.scss';

interface MediaListProps {
  items: string[];
  onClick: (index: number) => void;
}

export function MediaList({ items, onClick }: MediaListProps) {
  const [sliderRef, slider] = useKeenSlider({
    initial: 0,
    selector: `.${styles.Item}`,
    mode: 'free',
    slides: {
      perView: 'auto',
      spacing: 8,
    },
  });
  const { getImageUrl } = useImage();

  useEffect(() => {
    slider.current && slider.current.update();
  }, [slider, sliderRef]);

  const itemsMarkup = items.map((item, index) => {
    const handleClick = (e: MouseEvent) => {
      e.preventDefault();
      onClick(index);
    };
    const source = getImageUrl(item, '120');
    const fallback = getImageUrl(item);

    return (
      <div key={index} className={styles.Item}>
        <Image
          key={index}
          fallback={fallback}
          size="medium"
          source={source}
          alt=""
        />
        <button
          aria-haspopup="dialog"
          className={styles.Toggle}
          onClick={handleClick}
        >
          <span className={styles.ToggleText}>
            Open media {index + 1} in gallery view
          </span>
        </button>
      </div>
    );
  });

  return (
    <div ref={sliderRef} className={styles.MediaList}>
      {itemsMarkup}
    </div>
  );
}
